import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonCancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button',
    id: 'dangerModal.buttonCancel',
  },
});
